import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/lib/handbook/post-layout/post-layout-secondary.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><strong parentName="p">{`Please note: Unless otherwise stated, all outlines below are for Grades 11 and 12 together. All courses are SL and HL unless otherwise noted.`}</strong></p>
    <h2 {...{
      "id": "group-1-studies-in-language-and-literature",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#group-1-studies-in-language-and-literature",
        "aria-label": "group 1 studies in language and literature permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Group 1: Studies In Language And Literature`}</h2>
    <h3 {...{
      "id": "course-name-english-language-and-literature",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#course-name-english-language-and-literature",
        "aria-label": "course name english language and literature permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><em parentName="h3">{`Course Name:`}</em>{` English Language and Literature`}</h3>
    <h3 {...{
      "id": "course-content",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#course-content",
        "aria-label": "course content permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Course Content`}</h3>
    <p><strong parentName="p">{`Readers, writers and texts`}</strong></p>
    <p>{`Non-literary texts are chosen from a variety of sources and media to represent as wide a range of text types as possible, and works are chosen from a variety of literary forms. The study of the non-literary texts and works focuses on the nature of language and communication and the nature of literature and its study. This study includes the investigation of how texts themselves operate as well as the contexts and complexities of production and reception. Focus is on the development of personal and critical responses to the particulars of communication.`}</p>
    <p><strong parentName="p">{`Time and space`}</strong></p>
    <p>{`Non-literary texts and literary works are chosen from a variety of sources, literary forms and media that reflect a range of historical and/or cultural perspectives. Their study focuses on the contexts of language use and the variety of ways literary and non-literary texts might both reflect and shape society at large. The focus is on the consideration of personal and cultural perspectives, the development of broader perspectives, and an awareness of the ways in which context is tied to meaning.`}</p>
    <p><strong parentName="p">{`Intertextuality: connecting texts`}</strong></p>
    <p>{`Non-literary texts and literary works are chosen from a variety of sources, literary forms and media in a way that allows students an opportunity to extend their study and make fruitful comparisons. Their study focuses on intertextual relationships with possibilities to explore various topics, thematic concerns, generic conventions, modes or literary traditions that have been introduced throughout the course. The focus is on the development of critical response grounded in an understanding of the complex relationships among various text types.`}</p>
    <p><strong parentName="p">{`Outcomes`}</strong></p>
    <p>{`Know, understand and interpret:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`a range of texts, works and / or performances, and their meanings and implications`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`contexts in which texts are written and / or received`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`elements of literary, stylistic, rhetorical, visual and / or performance craft`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`features of particular text types and literary forms.`}</p>
      </li>
    </ul>
    <p>{`Analyse and evaluate:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`ways in which the use of language creates meaning`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`uses and effects of literary, stylistic, rhetorical, visual or theatrical techniques`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`relationships among different texts`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`ways in which texts may offer perspectives on human concerns`}</p>
      </li>
    </ul>
    <p>{`Communicate`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`ideas in clear, logical and persuasive ways`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`in a range of styles, registers and for a variety of purposes and situations`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`(for literature and performance only) ideas, emotion, character and atmosphere through performance.`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`Assessment (SL)`}</strong></p>
    <table><colgroup><col style={{
          "width": "81%"
        }} /><col style={{
          "width": "18%"
        }} /></colgroup><thead><tr className="header"><th><strong>Assessment Component</strong></th><th><strong>Weighting</strong></th></tr><tr className="odd"><th><p><strong>External assessment (3 hours)</strong></p><p><strong>Paper 1: Guided textual analysis (1 hour 15 minutes)</strong></p><p>The paper consists of two non-literary passages, from two different text types, each accompanied by a question. Students choose one passage and write an analysis of it. (20 marks)</p><p><strong>Paper 2: Comparative essay (1 hour 45 minutes)</strong></p><p>The paper consists of four general questions. In response to one question students write a comparative essay based on two works studied in the course. (30 marks)</p></th><th><strong>35%</strong></th></tr><tr className="header"><th><p><strong>Internal assessment</strong></p><p>This component consists of an individual oral which is internally assessed by the teacher and externally moderated by the IB at the end of the course.</p><p><strong>Individual oral (15 minutes)</strong></p><p>Supported by an extract from one non-literary text and one from a literary work, students will offer a prepared response of 10 minutes, followed by 5 minutes of questions by the teacher, to the following prompt:</p><p>Examine the ways in which the global issue of your choice is presented through the content and form of two of the texts that you have studied. (40 marks)</p></th><th><p><strong>35%</strong></p><p><strong>30%</strong></p></th></tr><tr className="odd"><th><strong>Assessment HL</strong></th><th></th></tr><tr className="header"><th><p><strong>Paper 1: Guided textual analysis (2 hours 15 minutes)</strong></p><p>The paper consists of two non-literary passages, from two different text types, each accompanied by a question. Students write an analysis of each of the passages. (40 marks)</p></th><th><strong>35%</strong></th></tr><tr className="odd"><th><p><strong>Paper 2: Comparative essay (1 hour 45 minutes)</strong></p><p>The paper consists of four general questions. In response to one question students write a comparative essay based on two works studied in the course. (30 marks)</p></th><th><strong>25%</strong></th></tr><tr className="header"><th><p><strong>HL essay</strong></p><p>Students submit an essay on one non-literary text or a collection of non-literary texts by one same author, or a literary text or work studied during the course. (20 marks)</p><p>The essay must be 1,200-1,500 words in length.</p></th><th><strong>20%</strong></th></tr><tr className="odd"><th><p><strong>Individual oral (15 minutes)</strong></p><p>Supported by an extract from both one non-literary text and one from a literary work, students will offer a prepared response of 10 minutes, followed by 5 minutes of questions by the teacher, to the following prompt:</p><p>Examine the ways in which the global issue of your choice is presented through the content and form of two of the works that you have studied. (40 marks)</p></th><th><strong>20%</strong></th></tr></thead><tbody></tbody></table>
    <p>{`RESOURCES/TEXTS/MATERIAL:`}</p>
    <p>{`Duffy, C. Selected poetry.`}</p>
    <p>{`Marquez, G. `}<em parentName="p">{`Chronicle of a Death Foretold.`}</em></p>
    <p>{`Noah, T. `}<em parentName="p">{`Born a Crime.`}</em></p>
    <p>{`Wilde, O. `}<em parentName="p">{`The Importance of Being Earnest`}</em></p>
    <p>{`Saadawi, N. `}<em parentName="p">{`Woman at Point Zero.`}</em></p>
    <p>{`Zamyatin, Y. `}<em parentName="p">{`We.`}</em></p>
    <p><strong parentName="p">{`COURSE NAME: French Language and Literature`}</strong></p>
    <p><strong parentName="p">{`COURSE CONTENT`}</strong></p>
    <table><colgroup><col style={{
          "width": "100%"
        }} /></colgroup><thead><tr className="header"><th><p><strong>Readers, writers and texts</strong></p><p>Non-literary texts are chosen from a variety of sources and media to represent as wide a range of text types as possible, and works are also chosen from a variety of literary forms. The study of the non-literary texts and works focuses on the nature of language and communication and the nature of literature and its study. This study includes the investigation of how texts themselves operate as well as the contexts and complexities of production and reception. Focus is on the development of personal and critical responses to the particulars of communication.</p></th></tr><tr className="odd"><th><p><strong>Time and space</strong></p><p>Non-literary texts and literary works are chosen from a variety of sources, literary forms and media that reflect a range of historical and/or cultural perspectives. Their study focuses on the contexts of language use and the variety of ways literary and non-literary texts might both reflect and shape society at large. The focus is on the consideration of personal and cultural perspectives, the development of broader perspectives, and an awareness of the ways in which context is tied to meaning.</p></th></tr><tr className="header"><th><p><strong>Intertextuality: connecting texts</strong></p><p>Non-literary texts and literary works are chosen from a variety of sources, literary forms and media in a way that allows students an opportunity to extend their study and make fruitful comparisons. Their study focuses on intertextual relationships with possibilities to explore various topics, thematic concerns, generic conventions, modes or literary traditions that have been introduced throughout the course. The focus is on the development of critical response grounded in an understanding of the complex relationships among texts.</p></th></tr></thead><tbody></tbody></table>
    <p><strong parentName="p">{`Outcomes`}</strong></p>
    <p>{`Know, understand and interpret:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`a range of texts, works and / or performances, and their meanings and implications`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`contexts in which texts are written and / or received`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`elements of literary, stylistic, rhetorical, visual and / or performance craft`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`features of particular text types and literary forms`}</p>
      </li>
    </ul>
    <p>{`Analyse and evaluate:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`ways in which the use of language creates meaning`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`uses and effects of literary, stylistic, rhetorical, visual or theatrical techniques`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`relationships among different texts`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`ways in which texts may offer perspectives on human concerns`}</p>
      </li>
    </ul>
    <p>{`Communicate`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`ideas in clear, logical and persuasive ways`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`in a range of styles, registers and for a variety of purposes and situations`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`(for literature and performance only) ideas, emotion, character and atmosphere through performance.`}</p>
      </li>
    </ul>
    <table><colgroup><col style={{
          "width": "87%"
        }} /><col style={{
          "width": "12%"
        }} /></colgroup><thead><tr className="header"><th><strong>Assessment (SL)</strong></th><th><strong>Weighting</strong></th></tr><tr className="odd"><th><p><strong>Paper 1: Guided textual analysis (1 hour 15 minutes)</strong></p><p>The paper consists of two non-literary passages, from two different text types, each accompanied by a question. Students choose one passage and write an analysis of it. (20 marks)</p><p><strong>Paper 2: Comparative essay (1 hour 45 minutes)</strong></p><p>The paper consists of four general questions. In response to one question students write a comparative essay based on two works studied in the course. (30 marks)</p></th><th><strong>35%</strong></th></tr><tr className="header"><th><p><strong>Internal assessment</strong></p><p>This component consists of an individual oral which is internally assessed by the teacher and externally moderated by the IB at the end of the course.</p><p><strong>Individual oral (15 minutes)</strong></p><p>Supported by an extract from one non-literary text and one from a literary work, students will offer a prepared response of 10 minutes, followed by 5 minutes of questions by the teacher, to the following prompt:</p><p>Examine the ways in which the global issue of your choice is presented through the content and form of two of the texts that you have studied. (40 marks)</p></th><th><p><strong>35%</strong></p><p><strong>30%</strong></p></th></tr><tr className="odd"><th><strong>Assessment (HL)</strong></th><th></th></tr><tr className="header"><th><p><strong>Paper 1: Guided textual analysis (2 hours 15 minutes)</strong></p><p>The paper consists of two non-literary passages, from two different text types, each accompanied by a question. Students write an analysis of each of the passages. (40 marks)</p></th><th><strong>35%</strong></th></tr><tr className="odd"><th><p><strong>Paper 2: Comparative essay (1 hour 45 minutes)</strong></p><p>The paper consists of four general questions. In response to one question, students write a comparative essay based on two works studied in the course. (30 marks)</p></th><th><strong>25%</strong></th></tr><tr className="header"><th><p><strong>HL essay</strong></p><p>Students submit an essay on one non-literary text or a collection of non-literary texts by the same author, or a literary text or work studied during the course. (20 marks)</p><p>The essay must be 1,200 - 1,500 words in length.</p></th><th><strong>20%</strong></th></tr><tr className="odd"><th><p><strong>Individual oral (15 minutes)</strong></p><p>Supported by an extract from both one non-literary text and one from a literary work, students offer a prepared response of 10 minutes, followed by 5 minutes of questions by the teacher, to the following prompt:</p><p>Examine the ways in which the global issue of your choice is presented through the content and form of two of the works that you have studied. (40 marks)</p></th><th><strong>20%</strong></th></tr></thead><tbody></tbody></table>
    <p><strong parentName="p">{`RESOURCES, TEXTS AND MATERIAL`}</strong></p>
    <p><strong parentName="p">{`fiction texts`}</strong></p>
    <p>{`Henrik Ibsen, `}<em parentName="p">{`Doll's house`}</em></p>
    <p>{`Edith Wharton, `}<em parentName="p">{`Ethan Frome`}</em></p>
    <p>{`Prosper Mérimée, short stories`}</p>
    <p>{`Jean Racine, `}<em parentName="p">{`Phèdre`}</em></p>
    <p>{`Honoré de Balzac, `}<em parentName="p">{`Eugénie Grandet`}</em></p>
    <p>{`Molière, `}<em parentName="p">{`L'avare`}</em></p>
    <p>{`Charles Baudelaire, `}<em parentName="p">{`Les fleurs du mal`}</em></p>
    <p><strong parentName="p">{`Non-fiction texts`}</strong></p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`advertisements`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`reviews`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`newspaper articles`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`information leaflets`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`magazine articles`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`feature articles`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`media texts`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`accounts of famous events`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`radio and television programmes and their scripts`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`photographs`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`press cartoons`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`COURSE NAME: DP Russian Language and Literature SL and HL`}</strong></p>
    <table><colgroup><col style={{
          "width": "100%"
        }} /></colgroup><thead><tr className="header"><th><p><strong>Readers, writers and texts</strong></p><p>Non-literary texts are chosen from a variety of sources and media to represent as wide a range of text types as possible, and works are chosen from a variety of literary forms. The study of the non-literary texts and works focuses on the nature of language and communication and the nature of literature and its study. This study includes the investigation of how texts themselves operate as well as the contexts and complexities of production and reception. Focus is on the development of personal and critical responses to the particulars of communication.</p></th></tr><tr className="odd"><th><p><strong>Time and space</strong></p><p>Non-literary texts and literary works are chosen from a variety of sources, literary forms and media that reflect a range of historical and/or cultural perspectives. Their study focuses on the contexts of language use and the variety of ways literary and non-literary texts might both reflect and shape society at large. The focus is on the consideration of personal and cultural perspectives, the development of broader perspectives, and an awareness of the ways in which context is tied to meaning.</p></th></tr><tr className="header"><th><p><strong>Intertextuality: connecting texts</strong></p><p>Non-literary texts and literary works are chosen from a variety of sources, literary forms and media in a way that allows students an opportunity to extend their study and make fruitful comparisons. Their study focuses on intertextual relationships with possibilities to explore various topics, thematic concerns, generic conventions, modes or literary traditions that have been introduced throughout the course. The focus is on the development of critical response grounded in an understanding of the complex relationships among texts.</p></th></tr></thead><tbody></tbody></table>
    <p><strong parentName="p">{`Outcomes`}</strong></p>
    <p>{`Know, understand and interpret:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`a range of texts, works and / or performances, and their meanings and implications`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`contexts in which texts are written and / or received`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`elements of literary, stylistic, rhetorical, visual and / or performance craft`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`features of particular text types and literary forms.`}</p>
      </li>
    </ul>
    <p>{`Analyse and evaluate:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`ways in which the use of language creates meaning`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`uses and effects of literary, stylistic, rhetorical, visual or theatrical techniques`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`relationships among different texts`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`ways in which texts may offer perspectives on human concerns.`}</p>
      </li>
    </ul>
    <p>{`Communicate`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`ideas in clear, logical and persuasive ways`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`in a range of styles, registers and for a variety of purposes and situations`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`(for literature and performance only) ideas, emotion, character and atmosphere through performance.`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`Assessment (SL)`}</strong></p>
    <p><strong parentName="p">{`External assessment (3 hours)`}</strong></p>
    <p><strong parentName="p">{`Paper 1: Guided textual analysis (1 hour 15 minutes)`}</strong></p>
    <p>{`The paper consists of two non-literary passages, from two different text types, each accompanied by a question. Students choose one passage and write an analysis of it. (20 marks) 35%`}</p>
    <p><strong parentName="p">{`Paper 2: Comparative essay (1 hour 45 minutes)`}</strong></p>
    <p>{`The paper consists of four general questions. In response to one question students write a comparative essay based on two works studied in the course. (30 marks) 35%`}</p>
    <p><strong parentName="p">{`Internal assessment`}</strong></p>
    <p>{`This component consists of an individual oral which is internally assessed by the teacher and externally moderated by the IB at the end of the course.`}</p>
    <p><strong parentName="p">{`Individual oral (15 minutes)`}</strong></p>
    <p>{`Supported by an extract from one non-literary text and one from a literary work, students will offer a prepared response of 10 minutes, followed by 5 minutes of questions by the teacher, to the following prompt:`}</p>
    <p>{`Examine the ways in which the global issue of your choice is presented through the content and form of two of the texts that you have studied. (40 marks) 30%`}</p>
    <p><strong parentName="p">{`Assessment HL`}</strong></p>
    <p><strong parentName="p">{`Paper 1: Guided textual analysis (2 hours 15 minutes)`}</strong></p>
    <p>{`The paper consists of two non-literary passages, from two different text types, each accompanied by a question. Students write an analysis of each of the passages. (40 marks) 35%`}</p>
    <p><strong parentName="p">{`Paper 2: Comparative essay (1 hour 45 minutes)`}</strong></p>
    <p>{`The paper consists of four general questions. In response to one question students write a comparative essay based on two works studied in the course. (30 marks) 25%`}</p>
    <p><strong parentName="p">{`HL essay`}</strong></p>
    <p>{`Students submit an essay on one non-literary text or a collection of non-literary texts by one same author, or a literary text or work studied during the course. (20 marks)`}</p>
    <p>{`The essay must be 1200-1500 words in length. 20%`}</p>
    <p><strong parentName="p">{`Individual oral (15 minutes)`}</strong></p>
    <p>{`Supported by an extract from both one non-literary text and one from a literary work, students will offer a prepared response of 10 minutes, followed by 5 minutes of questions by the teacher, to the following prompt:`}</p>
    <p>{`Examine the ways in which the global issue of your choice is presented through the content and form of two of the works that you have studied. (40 marks) 20%`}</p>
    <p>{`RESOURCES/TEXTS/MATERIAL`}</p>
    <p>{`Various media advertisements Various non-fiction text types Political Speeches Children’s Literature Religious Texts Newspaper articles`}</p>
    <p>{`Photographs Lermontov, M. `}<em parentName="p">{`Hero of Our Time`}</em>{` Shaw, B. `}<em parentName="p">{`Pygmalion`}</em></p>
    <p>{`Bulgakov, M. `}<em parentName="p">{`Dog’s Heart`}</em>{` Ahmatova, A. `}<em parentName="p">{`Requiem`}</em>{` Chekhov, `}<em parentName="p">{`The Cherry Orchard`}</em></p>
    <h2 {...{
      "id": "group-2-language-acquisition",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#group-2-language-acquisition",
        "aria-label": "group 2 language acquisition permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Group 2: Language Acquisition`}</h2>
    <p><strong parentName="p">{`COURSE NAME: DP English Language Acquisition`}</strong></p>
    <p>{`SYLLABUS CONTENT: (Standard and Higher Level)`}</p>
    <p>{`Year 1`}</p>
    <p>{`Unit 1: Introduction to the Key Themes`}</p>
    <p>{`Unit 2: Identity- Citizens of the World`}</p>
    <p>{`Unit 3: Experiences- Defining Moments`}</p>
    <p>{`Unit 4: Human Ingenuity: Rethinking Art and Technology`}</p>
    <p>{`Unit 5: Novel Study`}</p>
    <p>{`Year 2`}</p>
    <p>{`Unit 5: Sharing the Planet: Roles and Responsibilities`}</p>
    <p>{`Unit 6: Social Organizations: Groups and Belonging`}</p>
    <p>{`Unit 7: Novel Study`}</p>
    <p>{`Unit 8: Theme Overview and Assessment Practice`}</p>
    <p>{`OUTCOMES:`}</p>
    <p>{`Upon successfully completing the course, students will be able to do the following:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Communicate clearly and effectively in a range of situations`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Understand and accurately use oral and written forms of English in a range of styles and situations`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Understand and use a wide range of vocabulary`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Select an appropriate register and style for varying situations`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Express ideas with general clarity and fluency`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Structure arguments in a clear, coherent and convincing way`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Understand and analyse moderately complex written and spoken material`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Assess subtleties of the English language in a wide range of forms, styles and registers`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Show an awareness of, and sensitivity to, the cultures where English is spoken`}</p>
      </li>
    </ul>
    <p>{`ASSESSMENTS:`}</p>
    <p>{`Non fiction text creation - brochure, set of instructions, article to a newspaper, formal or informal letter`}</p>
    <p>{`Fiction text creation - Essays based on literature, creative story`}</p>
    <p>{`Oral text creation - Debates, speeches, presentations, classroom discussion`}</p>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <p>{`Henry, April: `}<em parentName="p">{`Girl, Stolen`}</em>{` Dick, Philip K.: `}<em parentName="p">{`Do Androids Dream of Electric Sheep?`}</em></p>
    <p>{`Asher, Jay: `}<em parentName="p">{`13 Reasons Why`}</em>{` Various Newspaper articles, personal accounts and speeches`}</p>
    <p><strong parentName="p">{`COURSE NAME: DP French Language Acquisition SL and HL, Grade 11 and 12`}</strong></p>
    <p>{`SYLLABUS CONTENT (Standard and Higher Level):`}</p>
    <p>{`Year 1`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Unit 1: Identities (Lifestyles, health and wellbeing, language and cultural identity or self identity)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 2: Experiences (Leisure activities, life stories, rites of passage, customs and traditions, migration)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 3: Human ingenuity (Entertainment, artistic expressions, communication and media, technology, scientific innovation)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 4: Schmitt, E.E. `}<em parentName="p">{`Oscar et la dame rose`}</em></p>
      </li>
    </ul>
    <p>{`Year 2`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Unit 5: Social organization (Social relationships, community, social engagement, education, the working worlds)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 6: Sharing the planet (Environment, human rights, peace and conflict, equality, globalisation, ethics, urban and rural environment)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 7: Nothomb, A. `}<em parentName="p">{`Antechrista`}</em></p>
      </li>
    </ul>
    <p>{`OUTCOMES:`}</p>
    <p>{`Upon successfully completing the course, students will be able to do the following:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Understand and use a range of vocabulary and grammar constructions`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Communicate clearly and effectively in a range of situations, both in written and oral form`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Write in formal and informal styles`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Understand and respond appropriately to written and spoken material`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Select a register that is generally appropriate to the situation`}</p>
      </li>
    </ul>
    <p>{`ASSESSMENTS:`}</p>
    <p>{`Write a formal or informal letter, article to a newspaper, interview, brochure, set of instructions, creative story`}</p>
    <p>{`Speeches / oral presentations Describe and react to a visual stimulus`}</p>
    <p>{`Classroom discussions / debates Reading comprehension`}</p>
    <p>{`Tests and quizzes Essays based on literature work (Higher level)`}</p>
    <u>Final assessments:</u>
    <p>{`Internal assessments: Individual oral activity (25%) External assessment:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Paper 1 - Written productive skills (25%)`}</p>
    </blockquote>
    <p>{`Paper 2: Receptive skills - Listening and reading (50%)`}</p>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <p>{`Abrioux`}<em parentName="p">{`,`}</em>{` A. `}<em parentName="p">{`Le monde en français`}</em></p>
    <p>{`Abrioux, A. `}<em parentName="p">{`French B for the IB Diploma, IB skills and practice`}</em></p>
    <p>{`Gregoire, M. `}<em parentName="p">{`Grammaire progressive`}</em></p>
    <p>{`Maun, I. `}<em parentName="p">{`Bien lire, bien écrire`}</em></p>
    <p>{`Miquel, C. `}<em parentName="p">{`Grammaire en dialogu`}</em>{`e`}</p>
    <p>{`Ollerenshaw, J. `}<em parentName="p">{`Facettes de la France contemporaine`}</em></p>
    <p>{`Trumper, C., Israel, J. `}<em parentName="p">{`French B Course Companion Second edition`}</em></p>
    <p>{`Selected poetry, short stories, magazines and newspapers`}</p>
    <p><strong parentName="p">{`COURSE NAME: DP Russian Language Acquisition SL and HL Grade 11 and 12`}</strong></p>
    <p>{`SYLLABUS CONTENT:`}</p>
    <p>{`Year 1`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Unit 1: Identities (Lifestyles, health and well-being, language and cultural identity or self identity)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 2: Experiences (Leisure activities, life stories)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 3: Human ingenuity (Entertainment, artistic expressions)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 4: Social organisation (Social relationships, community, social engagement, education, the working`}</p>
      </li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`worlds)`}</p>
    </blockquote>
    <ul>
      <li parentName="ul"><u>Higher Level only.</u> Literature: Lermontov’s *The Hero of Our Time*</li>
    </ul>
    <p>{`Year 2`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Unit 1: Experiences (rites of passage, customs and traditions, migration)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 2: Human ingenuity (Communication and media, technology, scientific innovation)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 3 : Sharing the planet (Environment, human rights, peace and conflict, equality, globalisation, ethics,`}</p>
      </li>
    </ul>
    <p>{`urban and rural environment)`}</p>
    <ul>
      <li parentName="ul"><u>Higher Level only.</u> Gorkiy’s *Staruha Izergil,* Selection of short stories</li>
    </ul>
    <p>{`OUTCOMES:`}</p>
    <p>{`Upon successfully completing the course, students will be able to do the following:`}</p>
    <blockquote>
      <p parentName="blockquote">{`● Understand and use a range of vocabulary and grammar constructions`}</p>
    </blockquote>
    <p>{`● Communicate clearly and effectively in a range of situations, both in written and oral form`}</p>
    <p>{`● Write in formal and informal styles`}</p>
    <p>{`● Understand and respond appropriately to written and spoken material`}</p>
    <p>{`● Select a register that is generally appropriate to the situation`}</p>
    <p>{`ASSESSMENTS:`}</p>
    <p>{`Write a formal or informal letter, article to a newspaper, interview, brochure, set of instructions, creative story`}</p>
    <p>{`Speeches / oral presentations`}</p>
    <p>{`Describe and react to a visual stimulus`}</p>
    <p>{`Classroom discussions / debates`}</p>
    <p>{`Reading comprehension`}</p>
    <p>{`Tests and quizzes`}</p>
    <p>{`Essays based on literature work (Higher level)`}</p>
    <u>Final assessments:</u>
    <p>{`Internal assessments: Individual oral activity (25%)`}</p>
    <p>{`External assessment: Paper 1 - Written productive skills (25%)`}</p>
    <p>{`Paper 2 - Receptive skills (50%)`}</p>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <p><em parentName="p">{`We Live and Study in Russia`}</em>{` Bogomolov, V. `}<em parentName="p">{`News from Russia`}</em>{` Golovko, A. `}<em parentName="p">{`Вперед`}</em></p>
    <p>{`Articles from magazines and newspapers Skorohodov, G. `}<em parentName="p">{`Window to Russia`}</em>{` Rifkin, B. `}<em parentName="p">{`Panorama`}</em></p>
    <p>{`Lermontov, M. `}<em parentName="p">{`The Hero of Our Time`}</em>{` Selected short stories Gorkiy, M.T`}<em parentName="p">{`he Old Izergil`}</em></p>
    <p>{`Volkova, Y. L`}<em parentName="p">{`et’s Improve Our Russian`}</em></p>
    <p><strong parentName="p">{`COURSE NAME: DP Spanish Language Acquisition SL, Grade 11 and 12`}</strong></p>
    <p>{`SYLLABUS CONTENT (Standard and Higher Level):`}</p>
    <p>{`Year 1`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Unit 1: Social organization ( Social relationships, community, social engagement, education, the working worlds)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 2: Human ingenuity (Entertainment, artistic expressions, communication and media, technology, scientific innovation)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 3: Experiences (Leisure activities, life stories, rites of passage, customs and traditions, migration)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 4: Sharing the planet (Environment, human rights, peace and conflict, equality, globalisation, ethics, urban and rural environment)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 5: Identities (Lifestyles, health and wellbeing, language and cultural identity or self identity)`}</p>
      </li>
    </ul>
    <p>{`Year 2`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Unit 1: Social organization ( Social relationships, community, social engagement, education, the working worlds)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 2: Human ingenuity (Entertainment, artistic expressions, communication and media, technology, scientific innovation)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 3: Experiences (Leisure activities, life stories, rites of passage, customs and traditions, migration)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 4: Sharing the planet (Environment, human rights, peace and conflict, equality, globalisation, ethics, urban and rural environment)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 5: Identities (Lifestyles, health and wellbeing, language and cultural identity or self identity)`}</p>
      </li>
    </ul>
    <p>{`OUTCOMES:`}</p>
    <p>{`Upon successfully completing the course, students will be able to do the following:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Understand and use a range of vocabulary and grammar constructions`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Communicate clearly and effectively in a range of situations, both in written and oral form`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Write in formal and informal styles`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Understand and respond appropriately to written and spoken material`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Select a register that is generally appropriate to the situation`}</p>
      </li>
    </ul>
    <p>{`ASSESSMENTS:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Write a formal or informal letter, emails, blogs, diary entries, article to a newspaper, interview, brochure, set of instructions, creative story`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Speeches / oral presentations / debates`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Describe and react to a visual stimulus`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Classroom discussions / debates`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Reading comprehension`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Listening comprehension`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Tests and quizzes`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Essays, oral presentations and speeches based on literature work (Standard and Higher level)`}</p>
      </li>
    </ul>
    <u>Final assessments:</u>
    <p>{`Internal assessments: Individual oral activity (25%)`}</p>
    <p>{`External assessment:`}</p>
    <p>{`Paper 1 - Written productive skills (25%)`}</p>
    <p>{`Paper 2: Receptive skills - Listening and reading (50%)`}</p>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <p>{`Oxford, `}<em parentName="p">{`Spanish B (2nd) Edition, IB Diploma Programme`}</em></p>
    <p>{`Oxford, `}<em parentName="p">{`Spanish B, IB Diploma Programme`}</em></p>
    <p>{`Hodder Education, `}<em parentName="p">{`Spanish B for the IB Diploma`}</em></p>
    <p>{`Pearson, `}<em parentName="p">{`Abriendo paso. Temas y lecturas.`}</em></p>
    <p>{`McGraw Hill, `}<em parentName="p">{`Repaso. A Spanish Grammar Review Worktext`}</em></p>
    <p>{`Diverse videos`}</p>
    <p>{`Articles (newspapers, magazines, blogs)`}</p>
    <p>{`Letters, emails, posters, notes, journal entries`}</p>
    <p>{`Varied internet resources`}</p>
    <p>{`Selected poetry, short stories, novels, one play, magazines and newspapers`}</p>
    <p><strong parentName="p">{`COURSE NAME: DP French `}<em parentName="strong">{`Ab initio`}</em>{` Grade 12`}</strong></p>
    <p>{`SYLLABUS CONTENT:`}</p>
    <p>{`Unit 1: Identities (personal attributes, personal relationship, eating and drinking, physical well being)`}</p>
    <p>{`Unit 2: Experiences (daily routine, leisure, holidays, festivals and traditions)`}</p>
    <p>{`Unit 3: Human ingenuity (transport, entertainment, media, technology)`}</p>
    <p>{`Unit 4: Social organization (neighbourhood, education, the workplace, social issues)`}</p>
    <p>{`Unit 5: Sharing the planet (climate, physical geography, the environment, global issues)`}</p>
    <p>{`OUTCOMES:`}</p>
    <p>{`Upon successfully completing the course, students will be able to do the following:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Communicate clearly and effectively in a range of contexts and for a variety of purposes`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Understand and use language appropriate to a range of interpersonal and/or intercultural contexts and audience`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Understand and use language to express and respond to a range of ideas with fluency and accuracy`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Identify, organize and present ideas on a range of topics`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Understand, analyse and reflect upon a range of written, audio, visual and audio-visual texts`}</p>
      </li>
    </ul>
    <p>{`ASSESSMENTS:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Vocabulary quizzes`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Written assignments (creative writing and past papers)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Reading and listening comprehension`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Discussions based on visual, listening and written stimuli`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Oral presentations, interviews, role plays`}</p>
      </li>
    </ul>
    <u>IB Assessment Requirements</u>
    <ul>
      <li parentName="ul">{`External Assessment: Paper 1: Productive Skills (writing): 25%`}</li>
    </ul>
    <p>{`Paper 2: Receptive Skills (listening and reading comprehension): 50%`}</p>
    <ul>
      <li parentName="ul">{`Internal Assessment: Individual Oral: 25%`}</li>
    </ul>
    <p>{`RESOURCES:`}</p>
    <p>{`Articles (newspapers, magazines, blogs)`}</p>
    <p>{`Videos, commercials, movie trailers and podcasts`}</p>
    <p>{`Photos and images`}</p>
    <p>{`Advertisement`}</p>
    <p>{`Past test papers`}</p>
    <p>{`TEXT TYPES:`}</p>
    <p>{`Letters, emails, journal entries notes, invitations, brochures, blogs, articles, classified ads, cover letters, movie reviews,`}</p>
    <p>{`conversations, interviews`}</p>
    <p><strong parentName="p">{`COURSE NAME: DP Russian or DP Spanish `}<em parentName="strong">{`Ab initio`}</em>{` Grade 11 and Grade 12`}</strong></p>
    <p>{`SYLLABUS CONTENT:`}</p>
    <p>{`Unit 1: Identities (personal attributes, personal relationship, eating and drinking, physical well being)`}</p>
    <p>{`Unit 2: Experiences (daily routine, leisure, holidays, festivals and traditions)`}</p>
    <p>{`Unit 3: Human ingenuity (transport, entertainment, media, technology)`}</p>
    <p>{`Unit 4: Social organization (neighbourhood, education, the workplace, social issues)`}</p>
    <p>{`Unit 5: Sharing the planet (climate, physical geography, the environment, global issues)`}</p>
    <p>{`OUTCOMES:`}</p>
    <p>{`Upon successfully completing the course, students will be able to do the following:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Communicate clearly and effectively in a range of contexts and for a variety of purposes`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Understand and use language appropriate to a range of interpersonal and/or intercultural contexts and audience`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Understand and use language to express and respond to a range of ideas with fluency and accuracy`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Identify, organize and present ideas on a range of topics`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Understand, analyse and reflect upon a range of written, audio, visual and audio-visual texts`}</p>
      </li>
    </ul>
    <p>{`ASSESSMENTS:`}</p>
    <p>{`Class-Specific Assessments`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Quizzes and tests`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Written assignments (creative writing and past papers)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Reading and listening comprehension`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Discussions/debates based on visual, listening and written stimuli`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Oral presentations, role plays`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Design posters, brochures, websites, menus, etc.`}</p>
      </li>
    </ul>
    <u>IB Assessment Requirements</u>
    <ul>
      <li parentName="ul">{`External Assessment: Paper 1: Productive Skills (writing): 25%`}</li>
    </ul>
    <p>{`Paper 2: Receptive Skills (listening and reading comprehension): 50%`}</p>
    <ul>
      <li parentName="ul">{`Internal Assessment: Individual Oral: 25%`}</li>
    </ul>
    <table><colgroup><col style={{
          "width": "50%"
        }} /><col style={{
          "width": "50%"
        }} /></colgroup><thead><tr className="header"><th><p>SPANISH RESOURCES/TEXTS/MATERIALS:</p><p><em>Aula Internacional 1 and 2</em></p><p><em>Diverso Básico</em></p><p><em>Panorama Hispanohablante 1 and 2</em></p><p><em>Gente 1, 2 and 3</em></p><p><em>Students’ Basic Grammar of Spanish</em></p><p><em>Mary Glasgow</em> magazines and website</p><p>Diverse videos Articles (newspapers, magazines, blogs)</p><p>Letters, emails, posters, notes, journal entries</p><p>Past paper</p></th><th><p>RUSSIAN RESOURCES/TEXTS/MATERIALS:</p><p><em>Russian in an Easy Way</em></p><p><em>Мои друзья падежи</em></p><p><em>O. Долматова Точка RU</em></p><p><em>А. Куцарева-Жаме ‘</em>Спасибо’</p><p><em>Л. Вохмина ‘</em>Русский класс’</p><p><em>В. Ермаченкова ‘</em>Слово’</p><p><em>С. Чернышов ‘</em>Поехали’ , ч. 1-2</p></th></tr></thead><tbody></tbody></table>
    <h2 {...{
      "id": "group-3-individuals-and-societies",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#group-3-individuals-and-societies",
        "aria-label": "group 3 individuals and societies permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Group 3: Individuals And Societies`}</h2>
    <p><strong parentName="p">{`COURSE NAME: DP Business Management (SL and HL)`}</strong></p>
    <p>{`SYLLABUS CONTENT:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Unit 1: Business organization and environment (SL: 40 hrs., HL: 50 hrs.)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 2: Human resource management (SL: 15 hrs., HL: 30 hrs.)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 3: Finance and accounts (SL: 35 hrs., HL: 50 hrs.)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 4: Marketing (SL: 35 hrs., HL: 50 hrs.)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Unit 5: Operations management (SL: 10 hrs., HL: 30 hrs.)`}</p>
      </li>
    </ul>
    <p>{`LEARNING OUTCOMES:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Know and understand business management tools, techniques and theories, as well as the six concepts that underpin the subject (change, culture, ethics, globalization, innovation, and strategy).`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Apply and analyse knowledge and skills to a variety of real-world and fictional business situations and decision making.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Synthesise and evaluate business strategies and practices, as well as decisions and formulating recommendations, showing evidence of critical thinking.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Demonstrate a variety of appropriate skills to produce well-structured written material using business terminology, as well as selecting and using quantitative and qualitative business tools, techniques and methods.`}</p>
      </li>
    </ul>
    <p>{`ASSESSMENTS:`}</p>
    <p>{`SL:`}</p>
    <p><em parentName="p">{`External assessment (75%)`}</em></p>
    <p>{`● Paper 1 (1 hour 15 minutes): Problem solving based on known case study (40 marks) 30%`}</p>
    <p>{`● Paper 2 (1 hour 45 minutes): Responses based on stimulus material (50 marks) 45%`}</p>
    <p>{`Internal assessment (15 hours)`}</p>
    <p>{`● A written problem-solving commentary, 1,500 words (25 marks) 25%`}</p>
    <p>{`HL:`}</p>
    <p><em parentName="p">{`External assessment (75%)`}</em></p>
    <p>{`● Paper 1 (2 hour 15 minutes): Problem solving based on known case study (60 marks) 35%`}</p>
    <p>{`● Paper 2 (2 hours 15 minutes): Responses based on stimulus material (70 marks) 40%`}</p>
    <p>{`Internal assessment (30 hours):`}</p>
    <p>{`● Primary research around organizational problem solving, 2,000 words (25 marks) 25%`}</p>
    <p>{`RESOURCES/TEXTS/MATERIALS`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><em parentName="p">{`Oxford IB Diploma Programme: Business Management Course Companion`}</em>{`, Lomine, Muchena, and Pierce`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><em parentName="p">{`Business Management for the IB Diploma Study and Revision Guide`}</em>{`, Paul Hoang`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Various internet resources, including Level7 Education, Bloomberg, Forbes, Financial Times, and WSJ`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`COURSE NAME: DP Economics SL and HL`}</strong></p>
    <p>{`SYLLABUS CONTENT:`}</p>
    <p>{`Unit 1: Introduction to Economics (10 hours SL / 10 hours HL)`}</p>
    <p>{`Unit 2: Microeconomics (35 hours SL / 70 hours HL)`}</p>
    <p>{`Unit 3: Macroeconomics (40 hours SL / 75 hours HL)`}</p>
    <p>{`Unit 4: The Global Economy (45 hours SL / 65 hours HL)`}</p>
    <p>{`OUTCOMES:`}</p>
    <p>{`Upon successfully completing the course, students will be able to do the following:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`develop a critical understanding of a range of economic theories, models, ideas and tools in the areas of microeconomics, macroeconomics and the global economy`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`apply economic theories, models, ideas and tools and analyse economic data to understand and engage with real-world economic issues and problems facing individuals and societies`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`develop a conceptual understanding of individuals’ and societies’ economic choices, interactions, challenges and consequences of economic decision-making.`}</p>
      </li>
    </ul>
    <p>{`ASSESSMENTS:`}</p>
    <p>{`1.Three external examination papers:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Extended response paper`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Data Response paper`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Extension paper (HL only)`}</p>
      </li>
    </ul>
    <p>{`2`}{`.`}{` Internal Assessment (20 hours):`}</p>
    <ul>
      <li parentName="ul">{`Three 750 word commentaries on a current article dealing with an economics issue`}</li>
    </ul>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <p>{`Past examination papers and mark schemes when available`}</p>
    <p>{`Blink, J. and Dorton, I. `}<em parentName="p">{`Economics Course Companion`}</em></p>
    <p>{`Tragakes, E`}<em parentName="p">{`. IB Economics in a Nutshell`}</em></p>
    <p>{`Ziogas, C. `}<em parentName="p">{`Economics IB Study Guide`}</em></p>
    <p>{`Ziogas, C. `}<em parentName="p">{`Economics for the IB Diploma`}</em></p>
    <p>{`Welkers Wikinomics`}</p>
    <p>{`Tutor2U`}</p>
    <p>{`ACDC leadership`}</p>
    <p>{`EconPlus Videos`}</p>
    <p><em parentName="p">{`The Economist`}</em></p>
    <p>{`The World Bank`}</p>
    <p><strong parentName="p">{`COURSE NAME: DP Geography SL and HL`}</strong></p>
    <p>{`SYLLABUS CONTENT:`}</p>
    <p>{`Paper 1: Optional Themes`}</p>
    <p>{`1`}{`.`}{` Extreme Environments (30 hours)`}</p>
    <p>{`2`}{`.`}{` Hazards and Disasters (30 hours)`}</p>
    <p>{`3`}{`.`}{` Urban Environments (30 hours)`}</p>
    <p>{`Paper 2: Core Themes (70 hours)`}</p>
    <p>{`Unit 1: Changing Population`}</p>
    <p>{`Unit 2: Global Climate`}</p>
    <p>{`Unit 3: Global Resource (consumption and security)`}</p>
    <p>{`Paper 3: HL Extension (60 hours)`}</p>
    <p>{`Unit 1: Power, places, and networks`}</p>
    <p>{`Unit 2: Human development and diversity`}</p>
    <p>{`Unit 3: Global risk and resilience`}</p>
    <p>{`Part 4: Fieldwork – SL and HL (20 hours)`}</p>
    <p>{`OUTCOMES:`}</p>
    <p>{`At the end of this course, students will be able to do the following:`}</p>
    <blockquote>
      <p parentName="blockquote">{`● Understand the interrelationships between people, places, spaces and the environment`}</p>
    </blockquote>
    <p>{`● Show concern for human welfare and the quality of the environment`}</p>
    <p>{`● Understand the need for planning and sustainable management`}</p>
    <p>{`● Appreciate the relevance of geography in analysing contemporary issues and challenges, and develop a global perspective of diversity and change`}</p>
    <p>{`ASSESSMENTS:`}</p>
    <p>{`SL:`}</p>
    <p><em parentName="p">{`External assessment (2 hours 50 minutes) 75%`}</em></p>
    <p>{`● Paper 1 (1 hour 30 minutes): Core theme 40 marks) 40%`}</p>
    <p>{`● Paper 2 (1 hour 15 minutes): Two optional themes (50 marks) 35%`}</p>
    <p>{`Internal assessment (20 hours)`}</p>
    <p>{`● Written report based on fieldwork. Maximum 2,500 words (25 marks) 25%`}</p>
    <p>{`HL:`}</p>
    <p><em parentName="p">{`External assessment (4 hours 30 minutes) 80%`}</em></p>
    <p>{`● Paper 1 (1 hour 30 minutes): Core themes (60 marks) 25%`}</p>
    <p>{`● Paper 2 (2 hours): Three optional themes (50 marks) 35%`}</p>
    <p>{`● Paper 3 (1 hour): Higher level extension (28 marks) 20%`}</p>
    <p>{`Internal assessment (20 hours): Any topic from the syllabus`}</p>
    <p>{`● Written report based on fieldwork. Maximum 2,500 words (30 marks) 20%`}</p>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <p>{`Chrispin, J. and Jegede, F. `}<em parentName="p">{`Population, Resources and Development`}</em>{`.`}</p>
    <p>{`Coddrington, S. `}<em parentName="p">{`Planet Geography`}</em>{`.`}</p>
    <p>{`Cooke, B. and Nagle, G. `}<em parentName="p">{`Geography Course Companion`}</em></p>
    <p>{`Cooke, B. and Nagle, G. `}<em parentName="p">{`Geography Study Guide`}</em></p>
    <p>{`Waugh, Dv. `}<em parentName="p">{`Geography: An Integrated Approach`}</em></p>
    <p>{`BBC`}</p>
    <p>{`UN`}</p>
    <p><strong parentName="p">{`COURSE NAME: DP Global Politics`}</strong></p>
    <p>{`SYLLABUS CONTENT:`}</p>
    <p>{`Unit 1: Power, Sovereignty and Interdependence`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Nature of power`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Operation of state power in global politics`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Function and impact of international organisations and non-state actors in global politics`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Nature and extent of interactions in global politics`}</p>
      </li>
    </ul>
    <p>{`Unit 2: Human Rights`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Nature and evolution of human rights`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Codification, protection and monitoring of human rights`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Practice of human rights`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Debates surrounding human rights and their application: differing interpretations of justice, liberty and equality`}</p>
      </li>
    </ul>
    <p>{`Unit 3: Development`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Contested meanings of development`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Factors that may promote or inhibit development`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Pathways towards development`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Debates surrounding development: challenges of globalisation, inequality and sustainability`}</p>
      </li>
    </ul>
    <p>{`Unit 4: Peace and Conflict`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Contested meanings of peace, conflict and violence`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Causes and parties to conflict`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Evolution of conflict`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Conflict resolution and post-conflict transformation`}</p>
      </li>
    </ul>
    <p>{`Engagement Activity`}</p>
    <p><strong parentName="p">{`HIGHER LEVEL SYLLABUS CONTENT`}</strong>{` (as above, plus):`}</p>
    <ul>
      <li parentName="ul">{`Global political challenges case study (oral presentation)`}</li>
    </ul>
    <p>{`LEARNING OUTCOMES:`}</p>
    <p>{`At the end of the course students will be able to:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Know and understand the methods, techniques and approaches to understanding global political issues, as well as the sixteen key concepts which define the subject.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Learn how to analyze the origin, value, purpose and limitations of sources and events from different perspectives and at different levels of analysis, and to view them within a wider global context.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Show the ability to synthesize and evaluate information and political theory to develop deeper understandings of the nature of global politics.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Produce organized and critical written material using political terminology and demonstrating a substantial knowledge of the content areas covered.`}</p>
      </li>
    </ul>
    <p>{`ASSESSMENTS:`}</p>
    <p>{`SL:`}</p>
    <p><em parentName="p">{`External assessment (75%)`}</em></p>
    <p>{`● Paper 1 (1 hour 15 minutes): Source based responses (25 marks) 30%`}</p>
    <p>{`● Paper 2 (1 hour 45 minutes): Two essays (50 marks) 45%`}</p>
    <p>{`Internal assessment (20 hours)`}</p>
    <p>{`● Engagement Activity. Maximum 2,500 words (30 marks) 25%`}</p>
    <p>{`HL:`}</p>
    <p><em parentName="p">{`External assessment (60%)`}</em></p>
    <p>{`● Paper 1 (1 hour 15 minutes): Source based responses (25 marks) 20%`}</p>
    <p>{`● Paper 2 (2 hours 45 minutes): Three optional themes (60 marks) 40%`}</p>
    <p>{`Internal assessment (20 hours): `}<em parentName="p">{`(40%)`}</em></p>
    <p>{`● Global political challenge presentation (6 topics) 20%`}</p>
    <p>{`● Engagement Activity. Maximum 2,500 words (30 marks) 20%`}</p>
    <p>{`RESOURCES/TEXTS/MATERIALS`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`PSI Library catalogue (IB recommended reading list)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Internet resources (UN, BBC, The Guardian, CFR, Foreign Affairs, The Economist, Al Jazeera, podcasts, other news outlets, Youtube)`}</p>
      </li>
    </ul>
    {
      /* */
    }
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Oxford IBDP Global Politics Course Companion`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Pearson Baccalaureate Global Politics`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Global Politics, Andrew Heywood`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Prisoners of Geography, Tim Marshall`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`COURSE NAME: DP History`}</strong></p>
    <p>{`COURSE CONTENT:`}</p>
    <p><strong parentName="p">{`Prescribed Subject (Paper 1)`}</strong></p>
    <ul>
      <li parentName="ul">{`Conflict and Intervention (Genocide in Rwanda and Kosovo)`}</li>
    </ul>
    <p><strong parentName="p">{`History Topics (Paper 2)`}</strong></p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Authoritarian States. USSR - Lenin/Stalin, China - Mao, Egypt - Nasser`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Cold War. Stalin USSR and Western Europe; Nasser and Suez Crisis; Mao and the Chinese off-shore islands`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`History of Europe ( Paper 3) HL`}</strong></p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`12`}{`.`}{` Imperial Russia, revolution and the establishment of the Soviet Union (1855–1924)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`16`}{`.`}{` The Soviet Union and post-Soviet Russia (1924–2000)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`18`}{`.`}{` Post-war central and eastern Europe (1945-2000)`}</p>
      </li>
    </ul>
    <p>{`LEARNING OUTCOMES:`}</p>
    <p>{`At the end of the course students will be able to:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Know and understand the methods, techniques and approaches to history as a discipline, as well as the six themes which define the subject (change, continuity, significance, causation, consequences, and perspectives).`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Learn how to analyze historical sources and events from different perspectives.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Show the ability to synthesize and evaluate historical information from different eras and areas.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Produce organized and critical written material using historical terminology and demonstrating a substantial knowledge of the content areas covered.`}</p>
      </li>
    </ul>
    <p>{`ASSESSMENT:`}</p>
    <p><strong parentName="p">{`Paper 1 (1 hour) HL and SL`}</strong></p>
    <p><em parentName="p">{`Conflict and Intervention`}</em></p>
    <p>{`This prescribed subject focuses on genocide in the late twentieth century. Two case studies are prescribed, from different regions of the world, and both of these case studies must be studied. The first case study explores the causes and consequences of the Rwandan Genocide of 1994. The second case study examines the events in Kosovo in 1999.`}</p>
    <p>{`This is a source-based paper based on the prescribed subject. Students must answer four structured questions.`}</p>
    <p><strong parentName="p">{`Paper 2 (1 hour 30 minutes) HL and SL`}</strong></p>
    <p>{`Essay paper based on the 12 `}<em parentName="p">{`world history topics`}</em>{`. Answer two essay questions on two different topics from:`}</p>
    <p>{`Authoritarian states (20th century)`}</p>
    <p>{`The Cold War: Superpower tensions and rivalries (20th century)`}</p>
    <p><strong parentName="p">{`Historical Investigation`}</strong>{` (Internal Assessment in History)`}</p>
    <p>{`Students are required to complete a historical investigation on a `}<em parentName="p">{`topic of their choice`}</em>{`.`}</p>
    <p>{`(25% of final grade for SL and 20% for HL).`}</p>
    <p><strong parentName="p">{`Paper 3 (2 hours 30 minutes) The History of Europe, HL only`}</strong></p>
    <p>{`Students answer `}<em parentName="p">{`three essay questions on the following three European History topics`}</em>{`. `}<em parentName="p">{`Upto two questions may be answered from any one topic.`}</em></p>
    <p>{`Imperial Russia, revolution and the establishment of the Soviet Union (1855–1924)`}</p>
    <p>{`The Soviet Union and post-Soviet Russia (1924–2000)`}</p>
    <p>{`Post-war central and eastern Europe (1945–2000)`}</p>
    <p><strong parentName="p">{`RESOURCES/TEXTS/MATERIALS`}</strong></p>
    <p>{`History reference materials in PSI Library Online videos Teacher generated resources`}</p>
    <p>{`Internet resources Active History website`}</p>
    <p><em parentName="p">{`Cambridge History for the IB Diploma: Imperial Russia`}</em></p>
    <p><em parentName="p">{`Cambridge History for the IB Diploma: Soviet Union and Post-Soviet Russia`}</em></p>
    <p>{`Oxford IB: `}<em parentName="p">{`Conflict and Intervention`}</em></p>
    <p>{`Oxford IB: `}<em parentName="p">{`Cold War: Super-power tensions and rivalries`}</em></p>
    <p>{`Oxford IB: `}<em parentName="p">{`Authoritarian States`}</em></p>
    <h2 {...{
      "id": "group-4-experimental-sciences",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#group-4-experimental-sciences",
        "aria-label": "group 4 experimental sciences permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Group 4: Experimental Sciences`}</h2>
    <p><strong parentName="p">{`COURSE NAME: DP Biology SL and HL`}</strong></p>
    <p>{`SYLLABUS CONTENT:`}</p>
    <p>{`Topic 1: Cell Biology (15 hours)`}</p>
    <p>{`Topic 2: Molecular Biology (21 hours)`}</p>
    <p>{`Topic 3: Genetics (15 hours)`}</p>
    <p>{`Topic 4: Ecology (12 hours)`}</p>
    <p>{`Topic 5: Evolution and Biodiversity (12 hours)`}</p>
    <p>{`Topic 6: Human Physiology (20 hours)`}</p>
    <u>HL only</u>
    <p>{`Topic 7: Nucleic acids (9 hours)`}</p>
    <p>{`Topic 8: Metabolism, cell respiration and photosynthesis (14 hours)`}</p>
    <p>{`Topic 9: Plant biology (13 hours)`}</p>
    <p>{`Topic 10: Genetics and evolution (8 hours)`}</p>
    <p>{`Topic 11: Animal physiology (16 hours)`}</p>
    <p>{`Options: Neurobiology and Behavior, Biotechnology, Ecology, or Human Physiology (SL 15 hours / HL 25 hours)`}</p>
    <p>{`Lab hours: SL students must perform 40 hours and HL students 60 hours`}</p>
    <p>{`OUTCOMES:`}</p>
    <p>{`Upon successfully completing the course, students will be able to do the following:`}</p>
    <p>{`● Communicate knowledge using scientific terminology and vocabulary and detailed diagrams`}</p>
    <p>{`● Support an informed point of view with evidence during discussions`}</p>
    <p>{`● Design and perform laboratory investigations`}</p>
    <p>{`● Analyse data, draw relevant conclusions and evaluate experiments`}</p>
    <p>{`● Demonstrate personal skills of cooperation, perseverance and responsibility`}</p>
    <p>{`● Demonstrate the manipulative skills necessary to carry out scientific investigations with precision and`}</p>
    <p>{`safety`}</p>
    <p>{`ASSESSMENTS:`}</p>
    <p>{`● Tests and quizzes`}</p>
    <p>{`● Modeling Biological Processes`}</p>
    <p>{`● Laboratory investigations`}</p>
    <p>{`● Mock Exam`}</p>
    <p>{`IB Standard Level Assessment`}</p>
    <p>{`Paper 1 = 20%`}</p>
    <p>{`Paper 2 = 40%`}</p>
    <p>{`Paper 3 = 20%`}</p>
    <p>{`Internal Assessment = 20%`}</p>
    <p>{`IB Higher Level Assessment`}</p>
    <p>{`Paper 1 = 20%`}</p>
    <p>{`Paper 2 = 36%`}</p>
    <p>{`Paper 3 = 24%`}</p>
    <p>{`Internal Assessment = 20%`}</p>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <p>{`Allott, A. (2014). `}<em parentName="p">{`Biology: IB Study Guide 2014 Edition SL and HL`}</em>{`. Oxford: Oxford Press.`}</p>
    <p>{`Allott, A. (2014). `}<em parentName="p">{`IB Biology Course Book: 2014 Edition SL and HL`}</em>{`. Oxford: Oxford Press. Print and electronic.`}</p>
    <p>{`Clegg, C.J. (2007). `}<em parentName="p">{`Biology for the IB Diploma`}</em>{`. London: Hodder Education`}</p>
    <p><strong parentName="p">{`COURSE NAME: DP CHEMISTRY SL and HL`}</strong></p>
    <p>{`SYLLABUS CONTENT:`}</p>
    <p>{`Core (SL) 95 hours`}</p>
    <p>{`Topic 1: Stoichiometric relationships 13.5`}</p>
    <p>{`Topic 2: Atomic structure 6`}</p>
    <p>{`Topic 3: Periodicity 6`}</p>
    <p>{`Topic 4: Chemical bonding and structure 13.5`}</p>
    <p>{`Topic 5: Energetics/thermochemistry 9`}</p>
    <p>{`Topic 6: Chemical kinetics 7`}</p>
    <p>{`Topic 7: Equilibrium 4.5`}</p>
    <p>{`Topic 8: Acids and bases 6.5`}</p>
    <p>{`Topic 9: Redox processes 8`}</p>
    <p>{`Topic 10: Organic chemistry 11`}</p>
    <p>{`Topic 11: Measurement and data processing 10`}</p>
    <p>{`Additional higher level (AHL) 60 hours`}</p>
    <p>{`Topic 12: Atomic structure 2`}</p>
    <p>{`Topic 13: The periodic table—the transition metals 4`}</p>
    <p>{`Topic 14: Chemical bonding and structure 7`}</p>
    <p>{`Topic 15: Energetics/thermochemistry 7`}</p>
    <p>{`Topic 16: Chemical kinetics 6`}</p>
    <p>{`Topic 17: Equilibrium 4`}</p>
    <p>{`Topic 18: Acids and bases 10`}</p>
    <p>{`Topic 19: Redox processes 6`}</p>
    <p>{`Topic 20: Organic chemistry 12`}</p>
    <p>{`Topic 21: Measurement and analysis 2`}</p>
    <p>{`Options 15 hours (SL)/25 hours (HL)`}</p>
    <p>{`A: Materials`}</p>
    <p>{`B: Biochemistry`}</p>
    <p>{`C: Energy`}</p>
    <p>{`D: Medicinal chemistry`}</p>
    <p>{`OUTCOMES:`}</p>
    <p>{`Upon successfully completing the course, student will be able to do the following:`}</p>
    <blockquote>
      <p parentName="blockquote">{`● Understand, apply and use chemical facts, concepts, techniques and terminology`}</p>
    </blockquote>
    <p>{`● Construct, analyse and evaluate chemical hypotheses, research questions and predictions`}</p>
    <p>{`● Demonstrate personal skills of cooperation, perseverance and responsibility`}</p>
    <p>{`● Demonstrate the manipulative skills necessary to carry out scientific investigations with precision and safety`}</p>
    <p>{`ASSESSMENTS:`}</p>
    <blockquote>
      <p parentName="blockquote">{`● Tests and quizzes`}</p>
    </blockquote>
    <p>{`● Assignments`}</p>
    <p>{`● Laboratory investigations`}</p>
    <p>{`● Mock Exam`}</p>
    <p>{`IB Standard Level Assessment`}</p>
    <p>{`Paper 1 = 20%`}</p>
    <p>{`Paper 2 = 40%`}</p>
    <p>{`Paper 3 = 20%`}</p>
    <p>{`Internal Assessment = 20%`}</p>
    <p>{`IB Higher Level Assessment`}</p>
    <p>{`Paper 1 = 20%`}</p>
    <p>{`Paper 2 = 36%`}</p>
    <p>{`Paper 3 = 24%`}</p>
    <p>{`Internal Assessment = 20%`}</p>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <p>{`Oxford University Press. `}<em parentName="p">{`Chemistry Course Companion`}</em></p>
    <p>{`Oxford University Press. `}<em parentName="p">{`IB Study Guide: Chemistry`}</em></p>
    <p><strong parentName="p">{`COURSE NAME: DP Design and Technology SL and HL`}</strong></p>
    <p><strong parentName="p">{`COURSE SYLLABUS CONTENT:`}</strong></p>
    <p><em parentName="p">{`Standard Level`}</em></p>
    <p>{`1`}{`.`}{` Human factors and ergonomics (12 hours)`}</p>
    <p>{`2`}{`.`}{` Resource management and sustainable production (22 hours)`}</p>
    <p>{`3`}{`.`}{` Modelling (12 hours)`}</p>
    <p>{`4`}{`.`}{` Raw material to final product (23 hours)`}</p>
    <p>{`5`}{`.`}{` Innovation and design (13 hours)`}</p>
    <p>{`6`}{`.`}{` Classic design (8 hours)`}</p>
    <p><em parentName="p">{`Higher Level`}</em></p>
    <p>{`7`}{`.`}{` User-centred design (UCD) (12 hours)`}</p>
    <p>{`8`}{`.`}{` Sustainability (14 hours)`}</p>
    <p>{`9`}{`.`}{` Innovation and markets (13 hours)`}</p>
    <p>{`10`}{`.`}{` Commercial production (15 hours)`}</p>
    <p><strong parentName="p">{`OUTCOMES:`}</strong></p>
    <p>{`Upon successfully completing this course, all students will be able to do the following:`}</p>
    <p>{`1`}{`.`}{` Demonstrate knowledge and understanding of:`}</p>
    <p>{`a`}{`.`}{` facts, concepts, principles and terminology`}</p>
    <p>{`b`}{`.`}{` design methodology and technology`}</p>
    <p>{`c`}{`.`}{` methods of communicating and presenting technological information.`}</p>
    <p>{`2`}{`.`}{` Apply and use:`}</p>
    <p>{`a`}{`.`}{` facts, concepts, principles and terminology`}</p>
    <p>{`b`}{`.`}{` design methodology and technology`}</p>
    <p>{`c`}{`.`}{` methods of communicating and presenting technological information`}</p>
    <p>{`3`}{`.`}{` Construct, analyse and evaluate:`}</p>
    <p>{`a`}{`.`}{` design briefs, problems, specifications and plans`}</p>
    <p>{`b`}{`.`}{` methods, techniques and products`}</p>
    <p>{`c`}{`.`}{` data, information and technological explanations`}</p>
    <p>{`4`}{`.`}{` Demonstrate the appropriate research, experimentation, modelling and personal skills necessary to carry out innovative, insightful, ethical and effective designing.`}</p>
    <p>{`ASSESSMENTS:`}</p>
    <p><em parentName="p">{`Standard Level`}</em></p>
    <p>{`Exam Paper 1: 30%`}</p>
    <p>{`Exam Paper 2: 30%`}</p>
    <p>{`Design Project: 40%`}</p>
    <p><em parentName="p">{`Higher Level`}</em></p>
    <p>{`Exam Paper 1: 20%`}</p>
    <p>{`Exam Paper 2: 20%`}</p>
    <p>{`Exam Paper 3: 20%`}</p>
    <p>{`Design Project: 40%`}</p>
    <p><em parentName="p">{`In class`}</em></p>
    <p>{`Past papers`}</p>
    <p>{`Quizzes`}</p>
    <p>{`Oral individual / group presentations`}</p>
    <p>{`Practical teacher directed activities, in preparation for the Design Project`}</p>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <p>{`Metcalfe, P. and Metcalfe, R. `}<em parentName="p">{`Design & Technology`}</em></p>
    <p>{`Smith, R. and Alder, S. (Aug 22, 2011). `}<a parentName="p" {...{
        "href": "http://www.amazon.com/Technology-Standard-Revision-International-Baccalaureate/dp/1907374108/ref=sr_1_1?ie=UTF8&qid=1395343790&sr=8-1&keywords=IB+DT"
      }}><em parentName="a">{`IB Design Technology Standard & Higher Level (OSC IB Revision Guides for the International Baccalaureate Diploma`}</em></a></p>
    <p>{`Students are also provided with a list of useful external websites.`}</p>
    <p><strong parentName="p">{`COURSE NAME: DP Environmental Systems and Societies – SL Only`}</strong></p>
    <p>{`SYLLABUS CONTENT:`}</p>
    <p>{`Topic 1— Foundations of Environmental Systems and Societies (16 hours)`}</p>
    <p>{`Topic 2—Ecosystems and Ecology (25 hours)`}</p>
    <p>{`Topic 3—Biodiversity and Conservation (13 hours)`}</p>
    <p>{`Topic 4—Water and Aquatic Food Production Systems and Societies (15 hours)`}</p>
    <p>{`Topic 5—Soil Systems and Terrestrial Food Production Systems and Societies (12 hours)`}</p>
    <p>{`Topic 6—Atmospheric Systems and Societies (10 hours)`}</p>
    <p>{`Topic 7—Climate Change and Energy Production (13 hours)`}</p>
    <p>{`Topic 8—Human Systems and Resource Use (16 hours)`}</p>
    <p>{`OUTCOMES:`}</p>
    <p>{`Upon successfully completing the course, students will be able to do the following:`}</p>
    <p>{`● Communicate knowledge using scientific terminology, vocabulary and detailed diagrams`}</p>
    <p>{`● Analyse case studies by identifying the appropriate information and applying past knowledge`}</p>
    <p>{`● Support an informed point of view with evidence during discussions`}</p>
    <p>{`● Design and perform laboratory investigations`}</p>
    <p>{`● Analyse data, draw relevant conclusions and evaluate experiments`}</p>
    <p>{`● Demonstrate personal skills of cooperation, perseverance and responsibility`}</p>
    <p>{`● Demonstrate the manipulative skills necessary to carry out scientific investigations with precision and`}</p>
    <p>{`safety`}</p>
    <p>{`ASSESSMENTS:`}</p>
    <p>{`● Tests and quizzes`}</p>
    <p>{`● Assignments`}</p>
    <p>{`● Laboratory investigations`}</p>
    <p>{`● Mock exam`}</p>
    <p>{`IB Standard Level Assessment`}</p>
    <p>{`Paper 1 = 25%`}</p>
    <p>{`Paper 2 = 50%`}</p>
    <p>{`Internal Assessment = 25%`}</p>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <p>{`Davis, A and Garrett, N (2015). `}<em parentName="p">{`Environmental Systems and Societies`}</em>{`. Essex: Pearson Baccalaureate`}</p>
    <p>{`Greenwood, T. et al. (2007) `}<em parentName="p">{`Environmental Science`}</em>{`. 2nd ed. Hamilton: Biozone International Ltd.`}</p>
    <p>{`Palmer, A (2010). `}<em parentName="p">{`IB Environmental Systems and Societies Revision Guide.`}</em>{` Oxford: Oxford Study Course`}</p>
    <p>{`Rutherford, J and Williams, G (2015). `}<em parentName="p">{`Environmental Systems and Societies.`}</em>{` Oxford: Oxford`}</p>
    <p>{`Students are also provided with a list of useful external websites.`}</p>
    <p><strong parentName="p">{`COURSE NAME: DP Physics SL and HL`}</strong></p>
    <p>{`SYLLABUS CONTENT (SL & HL):`}</p>
    <p>{`Unit 1: Measurements and Uncertainties (5 hours)`}</p>
    <p>{`Unit 2: Mechanics (22 hours)`}</p>
    <p>{`Unit 3: Thermal Physics (11 hours)`}</p>
    <p>{`Unit 4: Waves (15 hours)`}</p>
    <p>{`Unit 5: Electricity and Magnetism (15 hours)`}</p>
    <p>{`Unit 6: Circular Motion and Gravitation (5 hours)`}</p>
    <p>{`Unit 7: Atomic, Nuclear and Particle Physics (14 hours)`}</p>
    <p>{`Unit 8: Energy Production (8 hours)`}</p>
    <p>{`Unit 9: (HL only) Wave Phenomena (17 hours)`}</p>
    <p>{`Unit 10: (HL only) Fields (11 hours)`}</p>
    <p>{`Unit 11: (HL only) Electromagnetic Induction (16 hours)`}</p>
    <p>{`Unit 12: (HL only) Quantum and Nuclear Physics (16 hours)`}</p>
    <p>{`Option D: Astrophysics (15 hours at SL, 22 hours at HL)`}</p>
    <p>{`OUTCOMES:`}</p>
    <p>{`Upon successfully completing the course, students will be able to do the following:`}</p>
    <ul>
      <li parentName="ul">{`Demonstrate an understanding of, apply and use:`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`-Scientific facts and concepts`}</p>
    </blockquote>
    <p>{`-Scientific methods and techniques`}</p>
    <p>{`-Scientific terminology`}</p>
    <p>{`-Methods of presenting scientific information`}</p>
    <ul>
      <li parentName="ul">{`Construct, analyse and evaluate:`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`-Hypotheses, research questions and predictions`}</p>
    </blockquote>
    <p>{`-Scientific methods and techniques`}</p>
    <p>{`-Scientific explanations`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Demonstrate the personal skills of cooperation, perseverance and responsibility appropriate for effective scientific investigation and problem solving`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Demonstrate the manipulative skills necessary to carry out scientific investigations with precision and safety`}</p>
      </li>
    </ul>
    <p>{`ASSESSMENTS:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Tests and assignments, from DP past papers`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Laboratory investigations`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Group 4 Project`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Mock Exam`}</p>
      </li>
    </ul>
    <p>{`IB Standard Level Assessment`}</p>
    <p>{`Paper 1 = 20%`}</p>
    <p>{`Paper 2 = 40%`}</p>
    <p>{`Paper 3 = 20%`}</p>
    <p>{`Internal Assessment = 20%`}</p>
    <p>{`IB Higher Level Assessment`}</p>
    <p>{`Paper 1 = 20%`}</p>
    <p>{`Paper 2 = 36%`}</p>
    <p>{`Paper 3 = 24%`}</p>
    <p>{`Internal Assessment = 20%`}</p>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <p>{`Homer and Bowen-Jones `}<em parentName="p">{`Physics Course Companion`}</em>{`. Oxford University Press, 2014`}</p>
    <p>{`Kirk. `}<em parentName="p">{`IB Study Guides Physics`}</em>{`. Oxford: Oxford University Press, 2007`}</p>
    <p>{`Various websites`}</p>
    <h2 {...{
      "id": "group-5-mathematics",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#group-5-mathematics",
        "aria-label": "group 5 mathematics permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Group 5: Mathematics`}</h2>
    <p><strong parentName="p">{`COURSE NAME: Mathematics : Applications and interpretation (SL)`}</strong></p>
    <p>{`SYLLABUS CONTENT :`}</p>
    <p><strong parentName="p">{`Number & Algebra`}</strong>{`: Sequences and series, indices and logarithms, approximations and solving systems of linear and polynomial equations`}</p>
    <p><strong parentName="p">{`Functions`}</strong>{`: Equations of straight lines, curve sketching, modelling, inverse and composite functions`}</p>
    <p><strong parentName="p">{`Geometry & Trigonometry`}</strong>{`: Coordinate geometry, volume and surface areas of 3D shapes, trigonometry, bearings, circles.`}</p>
    <p><strong parentName="p">{`Statistics & Probability`}</strong>{`: Classification of data, sampling, presentation of data, measures of central tendency and dispersion, linear correlation, introduction to probability, Venn diagrams, discrete random variables, normal distribution, binomial distribution, Spearman’s rank correlation coefficient, hypothesis testing, Chi Square test, `}<strong parentName="p">{`Calculus`}</strong>{`: Introduction to limits, differentiation of polynomials functions, equations of tangents and normal, definite integrals, numerical methods.`}</p>
    <p>{`ASSESSMENTS:`}</p>
    <p>{`● Mathematical investigations`}</p>
    <p>{`● Tests and quizzes`}</p>
    <p>{`● Exam and Mock Exams`}</p>
    <p>{`The core topics are assessed through two written papers taken at the end of the course. These contribute 80% of the final mark. The Internal Assessment, which contributes the remaining 20% of the final mark is through a written mathematical exploration investigating an area of mathematics.`}</p>
    <p>{`OUTCOMES:`}</p>
    <p>{`Students will be able to do the following:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Understand and recall mathematical facts, concepts and techniques`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Recall, select and use their knowledge of mathematical skills to both abstract and real world contexts to solve problems`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Communicate and interpret their mathematics accurately`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Use technology accurately and efficiently to explore new ideas and solve problems Construct Mathematical arguments using precise language`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Investigate unfamiliar situations, making conjectures, drawing conclusions and testing their validity`}</p>
      </li>
    </ul>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <p>{`Blythe, P., et al. `}<em parentName="p">{`Mathematical Studies Standard Level. Course Companion`}</em>{`. Oxford University Press, 2012.`}</p>
    <p>{`Haese, M., et al. `}<em parentName="p">{`Mathematics: Applications and Interpretation SL, 2019`}</em></p>
    <p>{`Halsey, T., et al. `}<em parentName="p">{`Oxford IB Diploma Programme: IB Mathematics: applications and interpretation`}</em>{`, SL, Print and Enhanced Online Course Book Pack, 2019`}</p>
    <p>{`Inthinking`}</p>
    <p>{`IB Questionbank`}</p>
    <p>{`YouTube videos`}</p>
    <p><strong parentName="p">{`COURSE NAME: Mathematics: Analysis and Approaches HL`}</strong></p>
    <p>{`SYLLABUS CONTENT :`}</p>
    <p><strong parentName="p">{`Number & Algebra`}</strong>{`:`}</p>
    <p>{`Sequences and series, indices and logarithms, permutations and combinations, partial fractions, complex numbers, proof by induction`}</p>
    <p><strong parentName="p">{`Functions`}</strong>{`: Equations of straight lines, curve sketching, definition of function, quadratic functions, graph transformations, factor and remainder theorem, modulus function`}</p>
    <p><strong parentName="p">{`Geometry & Trigonometry`}</strong>{`: Coordinate geometry, volume and surface areas of 3D shapes, trigonometry, bearings, circles, reciprocal trigonometric ratios, compound angle identities, vectors`}</p>
    <p><strong parentName="p">{`Statistics & Probability`}</strong>{`: Classification of data, sampling, presentation of data, measures of central tendency and dispersion, linear correlation, introduction to probability, Venn diagrams, discrete random variables, normal distribution, binomial distribution, conditional probability, regression line x on y, Bayes’ Theorem, continuous random variables`}</p>
    <p><strong parentName="p">{`Calculus`}</strong>{`: Introduction to limits, differentiation of polynomials and basic trigonometric functions, equations of tangents and normal, definite integrals, chain, product and quotient rules, kinematics, indefinite integration and integration by substitution methods, numerical methods, understanding of limits, differentiation from first principles, L’Hopital’s Rule, implicit differentiation, related rates and optimisation, derivatives of more complex functions, integration by parts, volumes of revolution, first order differential equations, Maclaurin expansions`}</p>
    <p>{`OUTCOMES:`}</p>
    <p>{`Students will be able to do the following:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Recall, select and use their knowledge of mathematical facts, concepts and techniques in a variety of familiar and unfamiliar contexts.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Recall, select and use their knowledge of mathematical skills, results and models in both abstract and real-world contexts to solve problems.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Transform common realistic contexts into mathematics; comment on the context; sketch or draw mathematical diagrams, graphs or constructions both on paper and using technology; record methods, solutions and conclusions using standardized notation; use appropriate notation and terminology.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Use technology accurately, appropriately and efficiently both to explore new ideas and to solve problems.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Construct mathematical arguments through use of precise statements, logical deduction and inference and by the manipulation of mathematical expressions.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Investigate unfamiliar situations, both abstract and from the real world, involving organizing and analyzing information, making conjectures, drawing conclusions, and testing their validity.`}</p>
      </li>
    </ul>
    <p>{`ASSESSMENTS:`}</p>
    <p>{`Tests, quizzes, mock exams`}</p>
    <p>{`The core topics are assessed through `}<strong parentName="p">{`three written papers`}</strong>{` taken at the end of the course. These contribute 80% of the final mark. No technology will be allowed for one of these papers and the shorter paper will be focused on problem-solving questions.`}</p>
    <p>{`The `}<strong parentName="p">{`Internal assessment,`}</strong>{` which contributes the remaining 20% of the final mark, is through a written mathematical exploration investigating an area of mathematics`}</p>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <p>{`Halsey, T., et al. `}<em parentName="p">{`Oxford IB Diploma Programme: IB Mathematics: analysis and approaches`}</em>{`, HL, Print and Enhanced Online Course Book Pack, 2019`}</p>
    <p>{`Haese, M., et al., `}<em parentName="p">{`Mathematics: Core Topics HL,`}</em>{` 2019`}</p>
    <p>{`Garry, T., Wazir, I. `}<em parentName="p">{`HL Mathematics for the IB Diploma`}</em>{`, 2012.`}</p>
    <p>{`Martin, D., et al`}<em parentName="p">{`.`}</em>{` `}<em parentName="p">{`Mathematics for the International Student: Mathematics HL`}</em>{` SA, Australia: Haese Mathematics, 2012.`}</p>
    <p>{`Inthinking`}</p>
    <p>{`IB Questionbank`}</p>
    <p>{`YouTube videos`}</p>
    <p><strong parentName="p">{`COURSE NAME: Mathematics: Analysis and Approaches SL`}</strong></p>
    <p>{`SYLLABUS CONTENT`}</p>
    <p><strong parentName="p">{`Number & Algebra`}</strong>{`: Sequences and series, Indices and logarithms.`}</p>
    <p><strong parentName="p">{`Functions`}</strong>{`: Equations of straight lines, curve sketching, definition of function, quadratic functions, graph transformations`}</p>
    <p><strong parentName="p">{`Geometry & Trigonometry`}</strong>{`: Coordinate geometry, volume and surface areas of 3D shapes, trigonometry, bearings, circles`}</p>
    <p><strong parentName="p">{`Statistics & Probability`}</strong>{`: Classification of data, sampling, presentation of data, measures of central tendency and dispersion, linear correlation, introduction to probability, Venn diagrams, discrete random variables, normal distribution, binomial distribution.`}</p>
    <p><strong parentName="p">{`Calculus`}</strong>{`: Introduction to limits, differentiation of polynomials and basic trigonometric functions, equations of tangents and normal, definite integrals, chain, product and quotient rules, kinematics, indefinite integration and integration by substitution methods, numerical methods.`}</p>
    <p>{`OUTCOMES:`}</p>
    <p>{`Students will be able to do the following:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Recall, select and use their knowledge of mathematical facts, concepts and techniques in a variety of familiar and unfamiliar contexts.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Recall, select and use their knowledge of mathematical skills, results and models in both abstract and real-world contexts to solve problems.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Transform common realistic contexts into mathematics; comment on the context; sketch or draw mathematical diagrams, graphs or constructions both on paper and using technology; record methods, solutions and conclusions using standardized notation; use appropriate notation and terminology.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Use technology accurately, appropriately and efficiently both to explore new ideas and to solve problems.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Construct mathematical arguments through use of precise statements, logical deduction and inference and by the manipulation of mathematical expressions.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Investigate unfamiliar situations, both abstract and from the real world, involving organizing and analyzing information, making conjectures, drawing conclusions, and testing their validity.`}</p>
      </li>
    </ul>
    <p>{`ASSESSMENTS:`}</p>
    <p>{`Tests, quizzes, Mock exams`}</p>
    <p><strong parentName="p">{`Two`}</strong>{` written papers taken at the end of the course. These contribute 80% of the final mark. No technology will be allowed for one of these papers and the shorter paper will be focused on problem-solving questions.`}</p>
    <p>{`The `}<strong parentName="p">{`Internal assessment,`}</strong>{` which contributes the remaining 20% of the final mark, is through a written mathematical exploration investigating an area of mathematics`}</p>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <p>{`Fannon, P., Kadelburg, V., Woolley, B., and Ward, S. `}<em parentName="p">{`Mathematics Standard Level for the IB Diploma, 2012`}</em></p>
    <p>{`Haese, M., et al. `}<em parentName="p">{`Mathematics: Analysis and Approaches SL, 2019`}</em></p>
    <p>{`LaRondie, P., Fensom, J., Stevens, J. `}<em parentName="p">{`IB Course Companion: Mathematics Standard Level,`}</em>{` 2012.`}</p>
    <p>{`Martin, D., et al`}<em parentName="p">{`.`}</em>{` `}<em parentName="p">{`Mathematics for the International Student: Mathematics SL`}</em>{` SA, Australia: Haese Mathematics, 2012.`}</p>
    <p>{`Paul La Rondie., et al`}<strong parentName="p">{`*.`}</strong>{`Oxford IB Diploma Programme: IB Mathematics: analysis and approaches, Standard Level, Print and Enhanced Online Course Book Pack , 2019*`}</p>
    <p><strong parentName="p">{`COURSE NAME: PSI Mathematics`}</strong></p>
    <p>{`SYLLABUS CONTENT:`}</p>
    <p>{`● Unit 1: `}<em parentName="p">{`Number and Algebra`}</em>{` ( approximation, units of measurement, numerical planning and everyday decisions)`}</p>
    <p>{`● Unit 2:`}<em parentName="p">{`Ratio and Percentage`}</em>{` (converting and application of percentage and ratios)`}</p>
    <p>{`● Unit 3: `}<em parentName="p">{`Geometry and applications`}</em>{`( perimeter and area of basic shapes, geometry of 3D shapes, applications)`}</p>
    <p>{`● Unit 4: `}<em parentName="p">{`Descriptive Statistics`}</em>{` (Classifying data, ways to display data, measures of central tendency)`}</p>
    <p>{`● Unit 5: `}<em parentName="p">{`Sequences and Consumer Maths`}</em>{` (arithmetic sequences, percentage, discounts, loans, salary wages, simple and compound interest)`}</p>
    <p>{`● Unit 6: `}<em parentName="p">{`Probability`}</em>{` (sample space; probability of simple events, insurance, forecasts)`}</p>
    <p>{`OUTCOMES:`}</p>
    <p>{`Upon successfully completing the course, students will be able to do the following:`}</p>
    <p>{`● Read, interpret, and solve a given problem using appropriate mathematical terms, strategies and techniques`}</p>
    <p>{`● Organise and present information and data in tabular and / or diagrammatic form appropriate for further analysis`}</p>
    <p>{`● Recognise patterns and structures in a variety of situations, and make generalisations`}</p>
    <p>{`● Use appropriate technological devices as mathematical tools`}</p>
    <p>{`● Understand the practical applications of mathematics and demonstrate appropriate use of mathematical modeling`}</p>
    <p>{`● Demonstrate an understanding of both the significance and the reasonableness of results`}</p>
    <p>{`ASSESSMENTS:`}</p>
    <p>{`● Mathematical investigations`}</p>
    <p>{`● Tests and quizzes`}</p>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <p>{`Coad, M., et al. `}<em parentName="p">{`Mathematics for the International Student: Mathematical Studies SL.`}</em>{` Haese & Harris Press 2012`}</p>
    <h2 {...{
      "id": "group-6-art",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#group-6-art",
        "aria-label": "group 6 art permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Group 6: Art`}</h2>
    <p><strong parentName="p">{`COURSE NAME: DP Music SL and HL, Grade 11`}</strong></p>
    <p>{`SYLLABUS COMPONENTS `}<strong parentName="p">{`(Starting with Class of 2021):`}</strong></p>
    <p>{`Year 1`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Musical Perception: Study, analysis and examination, comparing and contrasting of musical cultures`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Creating: Music technology / composing / arranging / improvising / stylistic techniques`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Solo performing`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Group Performing`}</p>
      </li>
    </ul>
    <p>{`OUTCOMES:`}</p>
    <p>{`Upon completion of this course, students will be able to do the following:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Develop their knowledge and potential as musicians, both personally and collaboratively`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Display knowledge, understanding and perception of music in relation to time, place and cultures`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Use appropriate musical terminology to describe and reflect their critical understanding of music`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Analyse and compare music in relation to time, place and cultures`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Develop creative skills through exploration, control and development of musical elements (SL, HL)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Improve performance skills through solo music making (SL, HL) or group music making (SL)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Show critical-thinking skills through reflective thought.`}</p>
      </li>
    </ul>
    <p>{`ASSESSMENTS :`}</p>
    <p>{`Standard Level:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`External assessment:`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Listening paper (2h15)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Musical links Investigation`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Internal Assessment:`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Creating (2 pieces of coursework with recordings and written work)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Solo public performance (15 minutes)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Group public performance (20 - 30 minutes)`}</p>
      </li>
    </ul>
    <p>{`High Level:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`External assessment:`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Listening paper (3h)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Musical links investigation (written script)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Internal Assessment:`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Creating (3 pieces of work with recordings and written work)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Solo public performance (20 minutes)`}</p>
      </li>
    </ul>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Campbell, P.S. (2004) `}<em parentName="p">{`Teaching Music Globally.`}</em>{` New York, NY: Oxford University Press`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Harrison, M (2009) `}<em parentName="p">{`All about Music theory.`}</em>{` Milwaukee, WI: Hal Leonard Corporation`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`COURSE NAME: DP Theatre SL and HL`}</strong></p>
    <p>{`SYLLABUS CONTENT:`}</p>
    <p>{`Each of the four assessment tasks asks the students to do the following:`}</p>
    <ul>
      <li parentName="ul">{`Theatre in Context: Examine the personal, theoretical and cultural contexts that inform theatre-making`}</li>
    </ul>
    {
      /* */
    }
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Theatre Processes: Explore the skills, techniques and processes involved in theatre-making`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Presenting Theatre: Consider the staging and presentation of theatre with respect to intention and audience impact`}</p>
      </li>
    </ul>
    <p>{`OUTCOMES:`}</p>
    <p>{`Upon successfully completing the course, students will be able to do the following:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Demonstrate knowledge and understanding of the relationship between theatre and its contexts`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Demonstrate appropriate skills and techniques of different specialist roles: creator, director, designer, performer`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Demonstrate an understanding of production elements and theatre practices`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Evaluate critically a range of diverse performances`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Engage practically in creating and presenting performances, including a basic level of technical proficiency`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Reflect on their own development in theatre through continual self-evaluation and recording`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Acquire appropriate research skills and apply them`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Demonstrate an ability to interpret play texts and other types of performance texts analytically and imaginatively`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Demonstrate initiative and perseverance in both individual and group projects`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Evaluate the relevance of selected research sources to personal practice`}</p>
      </li>
    </ul>
    <p>{`ASSESSMENTS:`}</p>
    <p><strong parentName="p">{`Task 1: Solo Theatre Piece (HL ONLY - 35%)`}</strong></p>
    <p>{`Students research a theatre theorist, identify an aspect of their theory, and create a fully produced solo piece of theatre. Each student submits for assessment:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`A report (3000 words)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`A video recording of their entire solo theatre piece (4-8 minutes)`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`Task 2: Director’s Notebook (SL - 35%, HL - 20%)`}</strong></p>
    <p>{`Students research a published play and develop a director’s vision presenting their directorial and design intention. They also describe how they would direct two moments from the play. Each student submits for assessment:`}</p>
    <ul>
      <li parentName="ul">{`A Director’s Notebook (20 page maximum)`}</li>
    </ul>
    <p><strong parentName="p">{`Task 3: Research Presentation (SL - 30%, HL - 20%)`}</strong></p>
    <p>{`Students research and present the cultural and theoretical context of a world theatre tradition and identify one performance convention from that tradition to explore through a presentation of that convention in a moment of theatre. Each student submits for assessment:`}</p>
    <ul>
      <li parentName="ul">{`A video recording of the entire presentation (15 minutes maximum)`}</li>
    </ul>
    <p><strong parentName="p">{`Task 4: Collaborative Project (SL - 35%, HL - 25%)`}</strong></p>
    <p>{`Students collaboratively create, design, and present an original piece of theatre while document the process through a process portfolio. Each student submits for assessment:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`A process portfolio (15 pages maximum)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`A video recording as evidence of their specific contributions (4 minutes maximum)`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`This task is assessed internally.`}</strong></p>
    <p>{`RESOURCES:`}</p>
    <p>{`Grotowski, J. `}<em parentName="p">{`Towards a Poor Theatr`}</em>{`e`}</p>
    <p>{`Artaud, A. `}<em parentName="p">{`The Theatre and Its Double`}</em></p>
    <p>{`Brook, P. `}<em parentName="p">{`The Empty Space`}</em></p>
    <p>{`Bogart, A. `}<em parentName="p">{`Viewpoints`}</em></p>
    <p>{`Works of several playwrights including Caryl Churchill, Harold Pinter, and Tony Kushner`}</p>
    <p>{`Various internet resources and videos`}</p>
    <p>{`These vary based on the research projects and productions selected each year.`}</p>
    <p><strong parentName="p">{`COURSE NAME: DP Visual Arts SL and HL`}</strong></p>
    <p>{`SYLLABUS CONTENT:`}</p>
    <p>{`Topic 1: Interpretation of an Artwork (in connection with a museum visit )`}</p>
    <p>{`(introducing all DP VA components: `}<strong parentName="p">{`Comparative Study`}</strong>{`, `}<strong parentName="p">{`Process Portfolio`}</strong>{` and `}<strong parentName="p">{`Exhibition`}</strong>{`)`}</p>
    <p>{`Topic 2: Narrative (2D, non-digital)`}</p>
    <p>{`Topic 3: Power (Sculpture or Textile)`}</p>
    <p>{`Topic 4: `}<strong parentName="p">{`Comparative Study`}</strong>{` of artworks by artists from different cultural contexts`}</p>
    <p>{`Topic 5: Transformation (Digital or Lens-based)`}</p>
    <p>{`Topic 6: Individual studio work and documenting all processes in visual art journal in preparation for final assessments`}</p>
    <p>{`OUTCOMES:`}</p>
    <p>{`Upon successfully completing the course, students will be able to do the following:`}</p>
    <p>{`● Develop the skills and techniques of investigation—both visual and written`}</p>
    <p>{`● Relate art to its cultural, historical, and theoretical contexts`}</p>
    <p>{`● Explore art concepts and art elements`}</p>
    <p>{`● Develop and use the processes of art criticism and analysis`}</p>
    <p>{`● Develop confidence and expertise in the use of various media`}</p>
    <p>{`● Extend their knowledge of design`}</p>
    <p>{`● Share their work with an audience through displays and exhibitions including their final exhibit`}</p>
    <p>{`● Extend individual investigation to inform practical work`}</p>
    <p>{`● Make connections between ideas and practice—both their own and others`}</p>
    <p>{`ASSESSMENTS:`}</p>
    <p>{`Component 1: A Comparative Study (Externally Assessed 20%)`}</p>
    <p>{`Compare and contrast analysis of at least two artists, three artworks, techniques for making art and the theory behind the work`}</p>
    <p>{`SL/HL: 10-15 screens`}</p>
    <p>{`For HL students this will include 3-5 reflective slides on how this relates to their own work`}</p>
    <p>{`Component 2: A Process Portfolio (Externally Assessed 40%)`}</p>
    <p>{`Demonstration and engagement with a variety of different techniques, process, and concepts within an art journal`}</p>
    <p>{`Documentation of the creation of an individual body of work`}</p>
    <p>{`SL: 9-18 screens`}</p>
    <p>{`HL: 13-25 screens`}</p>
    <p>{`Component 3: An exhibition with written rationale (Internally Assessed 40%)`}</p>
    <p>{`Creation of a body of work for exhibition`}</p>
    <p>{`Students reflect on the decisions made during the creation process and the rationale for the selection of certain pieces for exhibition`}</p>
    <p>{`SL: 4-7 pieces with 2 reflective commentaries`}</p>
    <p>{`HL: 8-11 pieces with 4 reflective commentaries`}</p>
    <p>{`RESOURCES/TEXTS/MATERIALS:`}</p>
    <p><em parentName="p">{`Art21`}</em>{` `}{`[`}{`DVD`}{`]`}</p>
    <p>{`Wide range of museum sites and resources depending on students’ individual needs`}</p>
    <h2 {...{
      "id": "other",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#other",
        "aria-label": "other permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Other`}</h2>
    <p><strong parentName="p">{`COURSE NAME: Theory of Knowledge (TOK)`}</strong></p>
    <p><strong parentName="p">{`SYLLABUS CONTENT:`}</strong></p>
    <p>{`The TOK course plays a special role in the DP by providing an opportunity for students to reflect on the nature, scope and limitations of knowledge and the process of knowing. In this way, the main focus of TOK is not on students acquiring new knowledge but on helping students to reflect on, and put into perspective, what they already know.`}</p>
    <p><strong parentName="p">{`Grade 11: (2020-21)`}</strong></p>
    <p>{`Unit 1: Knowledge and the knower and overview of the Areas of Knowledge (AOK) and key concepts`}</p>
    <p>{`Unit 2: History`}</p>
    <p>{`Unit 3: Natural Sciences`}</p>
    <p>{`Unit 4: Human Sciences`}</p>
    <p>{`Unit 5: Optional theme`}</p>
    <p>{`Unit 6: Exhibition Internal Assessment`}</p>
    <p><strong parentName="p">{`Grade 12: (2021-22)`}</strong></p>
    <p>{`Unit 7: Arts`}</p>
    <p>{`Unit 8: Math`}</p>
    <p>{`Unit 9: Optional Theme`}</p>
    <p>{`Unit 10: Essay External Assessment`}</p>
    <p>{`Discussion of ‘knowledge questions’ and formative work on the assessments are distributed throughout the course.`}</p>
    <p><strong parentName="p">{`OUTCOMES:`}</strong></p>
    <p>{`• demonstrate TOK thinking through the critical examination of knowledge questions`}</p>
    <p>{`• identify and explore links between knowledge questions and the world around us`}</p>
    <p>{`• identify and explore links between knowledge questions and areas of knowledge`}</p>
    <p>{`• develop relevant, clear and coherent arguments`}</p>
    <p>{`• use examples and evidence effectively to support a discussion`}</p>
    <p>{`• demonstrate awareness and evaluation of different points of view`}</p>
    <p>{`• consider the implications of arguments and conclusions.`}</p>
    <p><strong parentName="p">{`ASSESSMENT`}</strong>{`:`}</p>
    <p><strong parentName="p">{`Internal Assessment: TOK Exhibition`}</strong></p>
    <p>{`The TOK exhibition assesses the ability of the student to show how TOK manifests in the world around us. The exhibition is an internal assessment component; it is marked by the teacher and is externally moderated by the IB.`}</p>
    <p><strong parentName="p">{`External Assessment: TOK Essay`}</strong></p>
    <p>{`The TOK essay engages students in a more formal and sustained piece of writing in response to a title focused on the areas of knowledge. The essay is an external assessment component; it is marked by IB examiners. The essay must be a maximum of 1,600 words and must be on one of the six prescribed titles issued by the IB for each examination session.`}</p>
    <p><strong parentName="p">{`RESOURCES/TEXTS/MATERIALS:`}</strong></p>
    <p>{`Teacher-Created Materials`}</p>
    <p>{`Various supplemental TOK textbooks, all provided by teachers as excerpts, as needed`}</p>
    <h2 {...{
      "id": "cas",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#cas",
        "aria-label": "cas permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`CAS`}</h2>
    <h3 {...{
      "id": "programme-name-creativity-actity-service--cas--community-service",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#programme-name-creativity-actity-service--cas--community-service",
        "aria-label": "programme name creativity actity service  cas  community service permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Programme Name: Creativity, Actity, Service ( Cas) / Community Service`}</h3>
    <p>{`PROGRAMME DESCRIPTION:`}</p>
    <p>{`There are two levels to this programme. Students preparing for the full IB Diploma work on CAS. Students who work for IB Certificates / the high school diploma must complete a community service requirement. We have outlined both below.`}</p>
    <p>{`CAS / Community Service is not a course for academic credit, and receives an Attitude & Application grade only on report cards. CAS is a requirement to earn the full IB Diploma. Community Service is a requirement for graduation from PSI. Students are expected to participate in either programme for 18 months and reflect on their experience. At last one service project must serve the community beyond PSI.`}</p>
    <p>{`CAS strands mean the following :`}</p>
    <p><strong parentName="p">{`Creativity`}</strong>{`—exploring and extending ideas leading to an original or interpretive product or performance`}</p>
    <p><strong parentName="p">{`Activity`}</strong>{`—physical exertion contributing to a healthy lifestyle`}</p>
    <p><strong parentName="p">{`Service`}</strong>{`—collaborative and reciprocal engagement with the community in response to an authentic need`}</p>
    <p>{`For students working toward certificates / the high school diploma, only the third strand is required.`}</p>
    <p><strong parentName="p">{`OUTCOMES:`}</strong></p>
    <p>{`As a result of their participation in CAS / Community Service, students will be able to do the following:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Identify own strengths and develop areas for growth`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Demonstrate that challenges have been undertaken, developing new skills in the process`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Demonstrate how to initiate and plan a CAS / Community Service project`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Show commitment to and perseverance in their experiences`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Demonstrate the skills and recognise the benefits of working collaboratively`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Demonstrate engagement with issues of global significance`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Recognise and consider the ethics of choices and actions`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`ASSESSMENT`}</strong>{`:`}</p>
    <p>{`CAS: Students’ work quality is assessed every quarter. Assessments focuses on fulfilment of the CAS Learning outcomes and is done by the CAS project supervisors and CAS Coordinator.`}</p>
    <p>{`Community Service: Students reflect quarterly on their service experiences and submit those to their project supervisor.`}</p>
    <p><strong parentName="p">{`EXAMPLES OF CURRENT PROJECTS:`}</strong></p>
    <p>{`Activity : Sport teams, individual sports`}</p>
    <p>{`Creativity : Music Band, Drama, Media`}</p>
    <p>{`Service : Kindergarten Teaching project, Animal Shelter, Visually Impaired support project`}</p>
    <p>{`Many projects combine more than one CAS strand : Kindergarten Building project ( Creativity, Activity, Service)`}</p>
    <p>{`Tutoring Centre ( Creativity, Service)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      